<template>
  <div class="page-content">
    <div class="card row">
      <div class="card-body col-md-12">
        <h5>Your Channel</h5>
        <hr/>
        <b-row>
          <b-col v-for="(ch, i) in channelList" :key="i" sm="6" md="3">
            <div @click="setActiveChannel(ch)" class="channel-card text-center" style="cursor: pointer">
              <h5>
                <a class="cursor-pointer"><span :class="ch.type"><i :class="ch.icon"></i></span>{{ ch.display_name }}</a>
              </h5>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import channelsAPI from '@/api/channels';
import popupErrorMessages from '@/library/popup-error-messages';

export default {
  name: 'ReportSession',
  metaInfo: {
    title: 'Report Sessions',
  },
  data() {
    return {
      loaderStack: 0,
      loader: null,
      channelList: [],
      search: '',
      availableType: {
        whatsapp: 'WhatsApp',
        sms: 'SMS',
      },
      availableChannel: [
        { name: 'WhatsApp', icon: 'mdi mdi-whatsapp', value: 'whatsapp' },
        // { name: 'Telegram', icon: 'mdi mdi-telegram', value: 'telegram' },
        { name: 'SMS', icon: 'mdi mdi-mailbox', value: 'sms' },
        { name: 'Email', icon: 'mdi mdi-email', value: 'email' },
        { name: 'WhatsApp Personal', icon: 'mdi mdi-whatsapp', value: 'whatsapp_personal' },
        // { name: 'WebChat', icon: 'mdi mdi-message-text', value: 'webchat' },
        // { name: 'Instagram', icon: 'mdi mdi-instagram', value: 'instagram' },
        { name: 'Facebook Messenger', icon: 'mdi mdi-facebook-messenger', value: 'fb_messenger' },
        { name: 'VoIP Call', icon: 'mdi mdi-phone', value: 'phone_call' },
        { name: 'Video Call', icon: 'mdi mdi-video', value: 'video_call' },
      ],
    };
  },
  computed: {
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace;
    },
  },
  mounted() {
    if (!this.activeWorkspace._id) {
      this.$router.push('/workspaces');
      return;
    }
    this.getChannelList();
  },
  methods: {
    showLoader() {
      if (this.loaderStack === 0) {
        this.loader = this.$loading.show();
      }
      this.loaderStack += 1;
    },
    hideLoader() {
      this.loaderStack -= 1;
      if (this.loaderStack === 0) {
        this.loader.hide();
      }
    },
    async getChannelList() {
      this.showLoader();
      await channelsAPI.getList(this.activeWorkspace._id, this.page, this.search)
        .then(async (res) => {
          await popupErrorMessages(res);
          this.channelList = res.data.channels.map((v) => {
            const key = this.availableChannel.find((k) => k.value === v.type);
            if (key) {
              v.icon = key.icon;
              v.display_name = key.name;
            } else {
              v.type = undefined;
            }
            return v;
          }).filter((v) => v.type);
        })
        .catch((err) => {
          console.error(err);
        });
      this.hideLoader();
    },
    async setActiveChannel(item) {
      const ch = this.availableChannel.find((v) => v.value === item.type);
      if (ch) {
        if (['whatsapp', 'phone_call', 'sms', 'email', 'video_call'].includes(item.type)) {
          this.$router.push({
            name: `Session Reports ${ch.name}`,
            params: {
              channel_id: item._id,
            },
          });
        } else {
          this.$router.push({
            name: 'Session Reports Others',
            params: {
              channel_id: item._id,
            },
          });
        }
      } else if (item.type === 'sms') {
        this.$router.push({
          name: 'Session Reports SMS',
          params: {
            channel_id: item._id,
          },
        });
      } else if (item.type === 'video_call') {
        this.$router.push({
          name: 'Session Reports Video Call',
          params: {
            channel_id: item._id,
          },
        });
      } else if (item.type === 'email') {
        this.$router.push({
          name: 'Session Reports Email',
          params: {
            channel_id: item._id,
          },
        });
      } else {
        this.$router.push({
          name: 'Coming Soon',
        });
      }
    },
  },
};
</script>
<style>
/*---------------------------*/
.channel-card{
  padding: 20px;
  box-shadow: 0 4px 9px rgba(0,0,0,0.08);
  margin-top: 35px;
  padding-top: 55px;
  position: relative;
  border: 1px solid #f4f4f4;
}
.channel-card a{
  color: #333;
}
.channel-card span{
  width: 70px;
  height: 70px;
  font-size: 36px;
  padding: 10px;
  color: #fff;
  text-align: center;
  padding-top: 12px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%,-50%);
  -moz-transform: translate(-50%,-50%);
  -webkit-transform: translate(-50%,-50%);
  border-radius: 8px;
}
</style>
